import React from 'react'

export default function ThankYouGtmIntelligence() {
  return (
    <div className="thankyou-wrapper thankyou-gtm-intelligence">
      <h1>Thank You!</h1>
      <p>
        We've received your request and will be in touch soon.
        <br />
        You’re one step closer to sharper GTM decisions powered by ProPlus Data.
        <br/>
        In the meantime, explore the success stories below.
      </p>
       <button  className="thankyou-btn" target="_blank" rel="noopener noreferrer"><a href='https://www.proplusdata.co/how-a-fortune-500-manufacturer-transformed-gtm-with-proplus'> Click Here </a></button>
    </div>
  )
}
